var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstragramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.734375,
    width: 37.5,
    height: 37.5,
    rx: 18.75,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2344 9H14.2344C11.473 9 9.23438 11.2386 9.23438 14V24C9.23438 26.7614 11.473 29 14.2344 29H24.2344C26.9958 29 29.2344 26.7614 29.2344 24V14C29.2344 11.2386 26.9958 9 24.2344 9Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2344 18.3701C23.3578 19.2023 23.2156 20.0523 22.8281 20.7991C22.4406 21.5459 21.8275 22.1515 21.076 22.5297C20.3245 22.908 19.4728 23.0397 18.6422 22.906C17.8115 22.7723 17.0441 22.3801 16.4492 21.7852C15.8543 21.1903 15.4621 20.4229 15.3285 19.5923C15.1948 18.7616 15.3265 17.91 15.7047 17.1584C16.083 16.4069 16.6886 15.7938 17.4354 15.4063C18.1822 15.0188 19.0321 14.8766 19.8644 15.0001C20.7133 15.1259 21.4992 15.5215 22.1061 16.1284C22.7129 16.7352 23.1085 17.5211 23.2344 18.3701Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7344 13.5H24.7444",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstragramIcon);
export default __webpack_public_path__ + "static/media/InstragramIcon.5f406bcee4ea6ba6a308644f41034f13.svg";
export { ForwardRef as ReactComponent };